import React, { useEffect, useState, useRef } from "react";
import {
  Breadcrumb,
  Row,
  Col,
  Card,
  Space,
  Button,
  Drawer,
  Descriptions,
  Anchor,
  Tag,
  notification,
  Modal,
  Input,
  Form,
  Select,
  DatePicker,
} from "antd";
import { ExclamationCircleOutlined, SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { Table } from "ant-table-extensions";
import http from "../../../../helpers/http";
import helper from "../../../../helpers/helper";
import config from "../../../../config/config";
import _ from "lodash";
import "./style.css";
function DiwaliBonanzaDailyWinners2025() {
  const { confirm } = Modal;
  const [loading, setloading] = useState(false);
  const [drawerOpen, setdraweropen] = useState(false);
  const [datas, setDatas] = useState([]);
  const [data, setData] = useState({});
  const [btnloading, setbtnloading] = useState(false);
  const [form] = Form.useForm();
  const [dates, setDates] = useState(null);
  const [formError, setFormError] = useState({});

  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const moduleNamePural = "Diwali Bonanza Daily Winners 2025";
  const base_url =
    config.api_url + "admin/leads/diwali-bonanza-2025-daily-winners"; //without trailing slash

  const azure_object_url =
    config.azure_object_url + "public/uploads/diwali-bonanza-2025/";
  const { Link } = Anchor;

  const handleView = async (id) => {
    const { data } = await http.get(`${base_url}/${id}`);

    if (data) {
      setData(data);
      setdraweropen(true);
    }
  };

  const handleDrawerClose = () => {
    setData({});
    setdraweropen(false);
  };

  const fetchDatas = async (fromDate = null, toDate = null) => {
    setloading(true);
    const data = await http.get(base_url, {
      params: { fromDate, toDate },
    });

    if (data) {
      setDatas(data.data);
    }
    setloading(false);
  };

  const handleDelete = async (id) => {
    const result = await http.delete(`${base_url}/${id}`);
    if (result) {
      notification["success"]({
        message: `Lead Deleted Successfully`,
      });
    }

    fetchDatas();
  };

  const showDeleteConfirm = (id) => {
    confirm({
      title: `Are you sure delete this Lead?`,
      icon: <ExclamationCircleOutlined />,
      content: "",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",

      onOk() {
        return handleDelete(id);
      },
      onCancel() {},
    });
  };

  const handleSubmit = async (value) => {
    // let errors = await validate(value);

    // setFormError(errors);

    // if (Object.keys(errors).length) {
    //   return;
    // }
    console.log({ dates });
    if (!dates) {
      setFormError({ dates: "Please select a date" });
    }

    if (dates) {
      setFormError({});

      setbtnloading(true);
      fetchDatas(dates[0], dates[1]);
      setbtnloading(false);
    }
  };

  useEffect(() => {
    fetchDatas();
  }, []);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => {
      return (
        <div
          style={{
            padding: 8,
          }}
        >
          <Input
            autoFocus
            placeholder="Type text here"
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              confirm({ closeDropdown: false });
            }}
            onPressEnter={() => {
              confirm();
            }}
            onBlur={() => {
              confirm();
            }}
            style={{
              marginBottom: 8,
              display: "block",
            }}
          ></Input>
          <Space>
            {/* <Button
           onClick={() => {
            clearFilters();
            setSelectedKeys(selectedKeys[0]);
            confirm();
           

          }}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button> */}
          </Space>
        </div>
      );
    },
    filterIcon: () => {
      return <SearchOutlined />;
    },
    onFilter: (value, record) => {
      return record[dataIndex].toLowerCase().includes(value.toLowerCase());
    },
  });

  const columns = [
    {
      title: "First Name",
      dataIndex: "first_name",
      key: "first_name",

      ellipsis: true,
    },
    {
      title: "Last Name",
      dataIndex: "last_name",
      key: "last_name",
      ellipsis: true,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Contact No",
      dataIndex: "phone",
      key: "phone",
      render: (text, record) => {
        return record.country_code + record.phone;
      },
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
    },
    {
      title: "Age",
      dataIndex: "age",
      key: "age",
    },

    {
      title: "Created At",
      render: (text, record) => {
        return helper.UserDate(record.createdAt, "-04:00");
      },
      key: "createdAt",
      dataIndex: "createdAt",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <Button
            onClick={() => {
              handleView(record._id);
            }}
          >
            View Detail
          </Button>
          {/* <Button
            type="danger"
            onClick={() => {
              showDeleteConfirm(record._id);
            }}
          >
            Delete
          </Button> */}
        </Space>
      ),
    },
  ];

  const fields: ITableExportFields = {
    first_name: "First Name",
    last_name: "Last Name",

    phone: {
      header: "Contact No",
      formatter: (_fieldValue, record) => {
        return record.country_code + record.phone;
      },
    },
    email: "Email Id",
    gender: "Gender",
    age: "Age",
    address: "Address",
    country: "Country",
    state: "State",

    city: {
      header: "City",
      formatter: (_fieldValue, record) => {
        return _.replace(_.deburr(record.city), /‘/g, "");
      },
    },
    zip: "Zip Code",
    store: "Which store did you buy this Laxmi product from?",
    campaign_source: "How did you get to know about this campaign?",
    laxmi_ads_desc: "Have you seen Laxmi ads before? if yes where?",
    laxmi_fav_product: "What is your favorite product from Laxmi?",



     laxmi_tagline: {
      header: "Suggest a tagline for Laxmi Brand",
      formatter: (_fieldValue, record) => {
        return record.laxmi_tagline || "NA";
      },
    },
   
    laxmi_brand_age: {
      header: "How old is Laxmi Brand?",
      formatter: (_fieldValue, record) => {
        return record.laxmi_brand_age || "NA";
      },
    },
    laxmi_found_year: {
      header: "In which year was Laxmi Brand founded?",
      formatter: (_fieldValue, record) => {
        return record.laxmi_found_year || "NA";
      },
    },
    laxmi_founder: {
      header: "Who is the founder of Laxmi Brand?",
      formatter: (_fieldValue, record) => {
        return record.laxmi_founder || "NA";
      },
    },
    laxmi_founding_city: {
      header: "In which city was Laxmi Brand first established?",
      formatter: (_fieldValue, record) => {
        return record.laxmi_founding_city || "NA";
      },
    },
    laxmi_logo_feature: {
      header: "What does the Laxmi Brand logo feature?",
      formatter: (_fieldValue, record) => {
        return record.laxmi_logo_feature || "NA";
      },
    },
    laxmi_best_product: {
      header: "Which product is Laxmi Brand best known for?",
      formatter: (_fieldValue, record) => {
        return record.laxmi_best_product || "NA";
      },
    },
    laxmi_serving_years: {
      header: "How many years has Laxmi Brand been serving families in the U.S.?",
      formatter: (_fieldValue, record) => {
        return record.laxmi_serving_years || "NA";
      },
    },

    laxmi_brand_one_word: "Can you Describe Laxmi Brand in one word?",
   
    is_qr_scanned: {
      header: "Is QR code scanned?",
      formatter: (_fieldValue, record) => {
        return record.coupon_code ? "Yes" : "No";
      },
    },
    coupon_code: {
      header: "Scan Code/QR Code",
      formatter: (_fieldValue, record) => {
        return record.coupon_code || "NA";
      },
    },

    invoice: {
      header: "Invoice",
      formatter: (_fieldValue, record) => {
        return record.invoice ? azure_object_url + record.invoice : "NA";
      },
    },

    createdAt: {
      header: "Created At",
      formatter: (_fieldValue, record) => {
        return helper.UserDate(record.createdAt, "-04:00");
      },
    },
  };

  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item>Leads</Breadcrumb.Item>
        <Breadcrumb.Item>{moduleNamePural}</Breadcrumb.Item>
      </Breadcrumb>
      <Row gutter={15}>
        <Col span={24}>
          <div className="site-card-border-less-wrapper">
            <Card title={moduleNamePural} bordered={false}>
              <Form layout="inline" form={form} onFinish={handleSubmit}>
                <Form.Item
                  label="Date:"
                  name="date"
                  {...(formError.dates && {
                    help: formError.dates,
                    validateStatus: "error",
                  })}
                  // style={{ width: 200 }}
                >
                  <RangePicker
                    value={dates}
                    placeholder={["From", "To"]}
                    variant="borderless"
                    onChange={(date, datestring) => {
                      console.log({ datestring });
                      setDates(datestring);
                    }}
                  />
                </Form.Item>

                {/* <Form.Item
                  label="Finalist:"
                  name="semifinalist"
                 
                >
                  <Select defaultValue="all">
                    <Option value="all">All</Option>
                    <Option value="yes">Yes</Option>
                    <Option value="no">No</Option>
                  </Select>
                </Form.Item> */}
                <Form.Item>
                  <Space>
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={btnloading}
                    >
                      Filter
                    </Button>
                    <Button
                      type="secondary"
                      onClick={() => {
                        window.location.reload();
                      }}
                    >
                      Reset
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
            </Card>
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <div className="site-card-border-less-wrapper">
            <Card bordered={false}>
              <Table
                rowKey={(record) => record._id}
                columns={columns}
                dataSource={datas}
                loading={loading}
                exportableProps={{
                  // showColumnPicker: true,
                  fields,
                  fileName: moduleNamePural,
                }}
                searchableProps={{
                  fuzzySearch: true,
                  // searchFunction:(dataSource,searchTerm)=>{
                  //   return dataSource;
                  // }
                  fuseProps: {
                    // distance:1000,
                    useExtendedSearch: true,
                  },
                }}
              />
            </Card>

            <Drawer
              title="Lead Details"
              placement="right"
              onClose={handleDrawerClose}
              visible={drawerOpen}
              size="large"
            >
              {data && (
                <Descriptions
                  bordered
                  column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                >
                  <Descriptions.Item label="First Name">
                    {data.first_name}
                  </Descriptions.Item>
                  <Descriptions.Item label="Last Name">
                    {data.last_name}
                  </Descriptions.Item>
                  <Descriptions.Item label="Contact No">
                    {data.country_code + data.phone}
                  </Descriptions.Item>
                  <Descriptions.Item label="Email Id">
                    {data.email}
                  </Descriptions.Item>
                  <Descriptions.Item label="Gender">
                    {data.gender}
                  </Descriptions.Item>
                  <Descriptions.Item label="Age">{data.age}</Descriptions.Item>
                  <Descriptions.Item label="Address">
                    {data.address}
                  </Descriptions.Item>
                  <Descriptions.Item label="Country">
                    {data.country || "-"}
                  </Descriptions.Item>
                  <Descriptions.Item label="State">
                    {data.state || "-"}
                  </Descriptions.Item>
                  <Descriptions.Item label="City">
                    {_.replace(_.deburr(data.city), /‘/g, "") || "-"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Zip Code">
                    {data.zip || "-"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Which store did you buy this Laxmi product from?">
                    {data.store}
                  </Descriptions.Item>
                  <Descriptions.Item label="How did you get to know about this campaign?">
                    {data.campaign_source}
                  </Descriptions.Item>
                  <Descriptions.Item label="Have you seen Laxmi ads before? if yes where?">
                    {data.laxmi_ads_desc}
                  </Descriptions.Item>
                  <Descriptions.Item label="What is your favorite product from Laxmi?">
                    {data.laxmi_fav_product}
                  </Descriptions.Item>


                  <Descriptions.Item label="Suggest a tagline for Laxmi Brand">
                    {data.laxmi_tagline || "NA"}
                  </Descriptions.Item>
                  <Descriptions.Item label="How old is Laxmi Brand?">
                    {data.laxmi_brand_age || "NA"}
                  </Descriptions.Item>
                  <Descriptions.Item label="In which year was Laxmi Brand founded?">
                    {data.laxmi_found_year || "NA"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Who is the founder of Laxmi Brand?">
                    {data.laxmi_founder || "NA"}
                  </Descriptions.Item>
                  <Descriptions.Item label="In which city was Laxmi Brand first established?">
                    {data.laxmi_founding_city || "NA"}
                  </Descriptions.Item>
                  <Descriptions.Item label="What does the Laxmi Brand logo feature?">
                    {data.laxmi_logo_feature || "NA"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Which product is Laxmi Brand best known for?">
                    {data.laxmi_best_product || "NA"}
                  </Descriptions.Item>
                  <Descriptions.Item label="How many years has Laxmi Brand been serving families in the U.S.?">
                    {data.laxmi_serving_years || "NA"}
                  </Descriptions.Item>




                  <Descriptions.Item label="Can you Describe Laxmi Brand in one word?">
                    {data.laxmi_brand_one_word}
                  </Descriptions.Item>
                  <Descriptions.Item label="Scan Code/QR Code">
                    {data.coupon_code || "NA"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Is QR code scanned?">
                    {data.coupon_code ? "Yes" : "No"}
                  </Descriptions.Item>
                  {data.invoice && (
                    <Descriptions.Item label="Invoice">
                      <a href={azure_object_url + data.invoice} target="_blank">
                        View Invoice
                      </a>
                    </Descriptions.Item>
                  )}

                  {/* <Descriptions.Item label="Consent">
                    <Tag color={data.consent ? "green" : "red"}>
                      {data.consent ? "Yes" : "No"}
                    </Tag>
                  </Descriptions.Item> */}
                  <Descriptions.Item label="Created At">
                    {helper.UserDate(data.createdAt, "-04:00")}
                  </Descriptions.Item>
                </Descriptions>
              )}
            </Drawer>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default DiwaliBonanzaDailyWinners2025;
